import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseApi } from "@/utils/baseApi";
export const shiftRosterListApi = baseApi.injectEndpoints({

    endpoints: (builder) => ({
        getShiftRoster: builder.query({
            query: ({ month, empId, sortDirection, page, size, search }) =>
                ({url: API_ENDPOINTS.SHIFT_ROSTER.GET_SHIFT_ROSTER(month, empId, sortDirection, page, size, search)}),
            providesTags: ["ShiftRoster"],
        }),

        getDayType: builder.query({
            query: ({ empId, month }) =>
                ({url: API_ENDPOINTS.SHIFT_ROSTER.GET_DAY_TYPE(empId, month)}),
            providesTags: ["DayType"],
        }),

    }),
});

export const { useGetShiftRosterQuery, useGetDayTypeQuery } = shiftRosterListApi;
